import { Colors } from '@sigma-frontend-libs/commons'
import { NOTIFICATIONS_SETTINGS_MY } from '@sigma-legacy-libs/essentials/lib/schemas/notifications'

export const notificationsColors = {
  email: Colors.email,
  sms: Colors.sms,
  web: Colors.web,
  tgBot: Colors.telegram,
  push: Colors.push
}

export const notificationsIcons = {
  me: 'user',
  child: 'users',
  users: 'users',
  manager: 'user-verified',
  managers: 'user-verified'
}

export const notificationsTypes = []
Object.keys(NOTIFICATIONS_SETTINGS_MY).map(key => {
  notificationsTypes.push(key.split('.').slice(2).join('.'))
})
